import { createSelector } from 'reselect'

const select = (state, stateName) => state[stateName]

const selectFaqs = createSelector(select, (content) =>
  content.items.filter((item) => item.contentType === 'faq')
)

const selectTutorials = createSelector(select, (content) =>
  content.items.filter((item) => item.contentType === 'tutorial')
)

export { selectFaqs, selectTutorials }
